import DistributorLayout from '@/layouts/DistributorLayout.vue'

export default [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/restricted/dashboard/DashboardView.vue'),
    meta: {
      requiresAuth: true,
      layout: DistributorLayout,
      menuSelected: 'dashboard'
    }
  },
  {
    path: '/repair-files',
    name: 'repairFiles',
    component: () => import('@/views/restricted/repair-files/RepairFileListView.vue'),
    meta: {
      requiresAuth: true,
      layout: DistributorLayout,
      permissions: ['DISTRIBUTOR_VIEW_ALL_SUMMARY_REPAIR_FILE'],
      menuSelected: 'repairFiles'
    }
  }
]
